import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAFLgVWolvHWVW153Bh1dJIBbDf-biXrvA",
  authDomain: "toptop-89ae0.firebaseapp.com",
  projectId: "toptop-89ae0",
  messagingSenderId: "56213826223",
  appId: "1:56213826223:web:5dd24e200f1fdc2276425a",
};

const app = initializeApp(firebaseConfig);

export let messaging = null;

export const messagingReady = isSupported().then((supported) => {
    if (supported) {
        messaging = getMessaging(app);
        console.log("Firebase Messaging 초기화 완료");
        return messaging;
    } else {
        console.log("Firebase Messaging 미지원 환경");
        return null;
    }
}).catch((err) => {
    console.log("Firebase Messaging 초기화 실패:", err);
    return null;
});

export default app;
